import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import GenereCsv from './GenereCsv';
import { FaTimes } from 'react-icons/fa';

const MyDatatable = ({ data, handleRowClick, columns, actif, subSelect }) => {

    const [searchText, setSearchText] = useState('');
    const [dataFiltered, setDataFiltered] = useState([]);
    const [columnsFiltered, setColumnsFiltered] = useState(columns);

    // États pour la pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        filtreData(data);
        // Ne pas reset la page ici, sauf si le filtre de recherche change
    }, [data, subSelect, searchText]);

    useEffect(() => {
        if (actif === false) {
            const newColumns = columns.filter((column, index) => !(index > 2 && index < 8));
            setColumnsFiltered(newColumns);
        } else {
            const newColumns = columns.filter((column, index) => index < 8);
            setColumnsFiltered(newColumns);
        }
    }, [columns, actif]);

    const filtreData = (donnees) => {
        // Ne pas reset la page ici
        setDataFiltered([]);
        setTimeout(() => {
            filtre(searchText, donnees, false);
        }, 0);
    }

    // resetPage = true si on veut revenir à la page 1 (changement de filtre)
    const filtre = (value, mydata, resetPage = true) => {
        let myDatatmp = [...mydata];

        if (subSelect === 'sansfeuille') {
            myDatatmp = mydata.filter(item => item.appels.filter(row2 => row2.is_actif === 0 && row2.has_selected_paiement === 0 && row2.has_merged === 0).length > 0);
        } else if (subSelect === 'avalider') {
            myDatatmp = mydata.filter(item => item.appels.filter(row2 => row2.is_actif === 1 && row2.has_selected_paiement === 1 && row2.has_merged === 0).length > 0);
        } else if (subSelect === 'tribuok') {
            myDatatmp = mydata.filter(item => item.identifiant_tribu && item.identifiant_tribu !== '' && item.tft_id && (((item.has_tribu === 1 && item.has_tribu_actif === 1) || (item.has_tribu === 0 && item.has_tribu_actif === 0)) || item.has_region === 1));
        } else if (subSelect === 'tribuko') {
            myDatatmp = mydata.filter(item =>
                (item.identifiant_tribu && item.identifiant_tribu !== ''
                    && !(((item.has_tribu === 1 && item.has_tribu_actif === 1) || (item.has_tribu === 0 && item.has_tribu_actif === 0)) || item.has_region === 1))
                || (!(item.identifiant_tribu && item.identifiant_tribu !== '') && item.has_tribu_actif === 1) || (item.has_tribu_actif === 1 && !item.tft_id));
        } else if (subSelect === 'tribucompte') {
            myDatatmp = mydata.filter(item => (item.has_tribu_actif === 1 || item.has_region === 1) && !(item.identifiant_tribu && item.identifiant_tribu !== ''));
        }

        setSearchText(value);
        if (value.length < 1) {
            setDataFiltered(myDatatmp);
        } else {
            const filtered = myDatatmp.filter(item => {
                return value.split(' ').every(word => {
                    return JSON.stringify(item).toLowerCase().includes(word.toLowerCase());
                });
            });
            setDataFiltered([...filtered].slice(0, filtered.length));
        }
        if (resetPage) setCurrentPage(1); // On ne reset la page que si c'est un vrai changement de filtre
    }

    const handleChangesearchText = (e) => {
        filtre(e.target.value, data, true); // reset page
    };

    const uniqueNetworks = [...new Set(data.map(row => row.reseau))].sort();
    const [selectedNetwork, setSelectedNetwork] = useState('');
    const handleNetworkFilter = (network) => {
        setSelectedFeuille('');
        setSelectedNetwork(network);
        if (network === '') {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => item.reseau === network);
            setDataFiltered(filtered);
        }
        setCurrentPage(1); // reset page car vrai changement de filtre
    };

    const uniqueFeuilles = [...new Set(data.map(row => row.appels.map(appel => appel.reference)).flat())].sort();
    const [selectedFeuille, setSelectedFeuille] = useState('');
    const handleFeuilleFilter = (feuille) => {
        setSelectedNetwork('');
        setSelectedFeuille(feuille);
        if (feuille === '') {
            setDataFiltered(data);
        } else {
            const filtered = data.filter(item => item.appels.find(e => e.reference === feuille) !== undefined);
            setDataFiltered(filtered);
        }
        setCurrentPage(1); // reset page car vrai changement de filtre
    };

    const customStyles = {
        headCells: {
            style: {
                justifyContent: 'center',
                textAlign: 'center',
            },
        },
    };

    // Composant de pagination personnalisé
    const CustomPagination = ({ rowsPerPage, rowCount, onChangePage, onChangeRowsPerPage, currentPage }) => {
        const totalPages = Math.ceil(rowCount / rowsPerPage);

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                color: 'rgba(0, 0, 0, 0.54)',
                fontSize: '13px'
            }}>
                <div>
                    <span style={{ marginRight: '10px' }}>
                        {((currentPage - 1) * rowsPerPage) + 1}-{Math.min(currentPage * rowsPerPage, rowCount)} sur {rowCount}
                    </span>
                    <button
                        onClick={() => onChangePage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ marginRight: '5px', padding: '5px 10px' }}
                    >
                        ‹
                    </button>
                    <button
                        onClick={() => onChangePage(currentPage + 1)}
                        disabled={currentPage >= totalPages}
                        style={{ padding: '5px 10px' }}
                    >
                        ›
                    </button>
                </div>
            </div>
        );
    };

    return (<>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ flexGrow: 1 }} />
            <h3 style={{ marginLeft: '10px' }}>{selectedNetwork}</h3>
            <div style={{ flexGrow: 1 }} />
            <Form.Select style={{ width: '300px' }} onChange={(e) => handleNetworkFilter(e.target.value)} value={selectedNetwork}>
                <option value="">Tous les réseaux</option>
                {uniqueNetworks.map((network, index) => <option key={index} value={network}>{network}</option>)}
            </Form.Select>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ flexGrow: 1 }} />
            <h3 style={{ marginLeft: '10px' }}>{selectedFeuille}</h3>
            <div style={{ flexGrow: 1 }} />
            <Form.Select style={{ width: '300px' }} onChange={(e) => handleFeuilleFilter(e.target.value)} value={selectedFeuille}>
                <option value="">Toutes les feuilles</option>
                {uniqueFeuilles.map((feuille, index) => <option key={index} value={feuille}>{feuille}</option>)}
            </Form.Select>
        </div>



        <DataTable
            columns={columnsFiltered}
            data={dataFiltered}
            pagination={true}
            paginationPerPage={perPage}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            paginationDefaultPage={currentPage}
            onChangePage={setCurrentPage}
            onChangeRowsPerPage={(newPerPage) => {
                setPerPage(newPerPage);
                setCurrentPage(1);
            }}
            highlightOnHover
            subHeader
            subHeaderComponent={(
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
                    <input
                        type="text"
                        value={searchText}
                        onChange={handleChangesearchText}
                        placeholder="Rechercher..."
                    />
                    {searchText && <FaTimes className='h-5' onClick={() => filtre('', data)} />}
                    <div style={{ flexGrow: 1 }} />
                    {/* <GenereCsv data={dataFiltered} fichier="Adherent" visible={true} /> */}
                    {/* Pagination du haut */}
                    <CustomPagination
                        rowsPerPage={perPage}
                        rowCount={dataFiltered.length}
                        onChangePage={setCurrentPage}
                        onChangeRowsPerPage={(newPerPage) => {
                            setPerPage(newPerPage);
                            setCurrentPage(1);
                        }}
                        currentPage={currentPage}
                    />
                </div>
            )}
            defaultSortField="id"
            defaultSortAsc={false}
            subHeaderAlign="left"
            noHeader={true}
            paginationComponentOptions={{
                rowsPerPageText: 'Lignes par page:',
            }}
            onRowClicked={handleRowClick}
            customStyles={customStyles}
        />
    </>
    );
}

export default MyDatatable;